export default __webpack_public_path__ + "static/media/expiryDate4.270a2c94.jpg";